import axios from "axios";

// In dev the vite proxy forwards /api to the local worker; in production
// VITE_API_URL points at the deployed api origin.
if (import.meta.env.PROD && !import.meta.env.VITE_API_URL) {
  console.warn(
    "[menu] VITE_API_URL tanımsız — istekler mevcut origin'e gidiyor",
  );
}

const AxiosClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL ?? ""}/menu/v1`,
  timeout: 10000,
});

export default AxiosClient;
